import { IInfrastructureItemV4 } from '../../repositories/infrastructure-caching/entities/newbuilding_infrastructure/InfrastructureItemV4';
import { IInfrastructurePoi, TInfrastructurePoiType } from '../../types/infrastructure';

const SUPPORTED_POI_TYPES: readonly TInfrastructurePoiType[] = ['cafe', 'clinic', 'grocery', 'nursery', 'school', 'metro'];

function isSupportedPoiType(type: IInfrastructureItemV4['type']): type is TInfrastructurePoiType {
  return (SUPPORTED_POI_TYPES as readonly string[]).includes(type);
}

/**
 * Переводит объекты инфраструктуры из ответа infrastructure-caching в точки для карты района.
 * Типы вне шести поддерживаемых (пляжи, парки и т.п.) отбрасываются — ячейка «Район» считает только эти шесть.
 */
export function mapPoisFromItems(items: IInfrastructureItemV4[]): IInfrastructurePoi[] {
  return items.filter(item => isSupportedPoiType(item.type)).map(item => ({
    id: item.id,
    type: item.type as TInfrastructurePoiType,
    title: item.title,
    coordinates: { lat: item.coordinates.lat, lng: item.coordinates.lng },
    lineColor: item.line?.color ?? null,
  }));
}
